import axios from 'axios'
import { Message } from 'element-ui'
import qs from 'qs'
import Vue from 'vue'
import Router from '@/router'
import Store from '@/vuex/store'

// const baseUrl = 'http://192.168.1.103:8084/'
// const baseUrl = "http://192.168.1.18:8084"
// const gasBaseUrl = 'http://192.168.1.33:8084/' //百汇
const warrantBaseUrl = 'http://27o325f587.zicp.vip/' //郑云正式
    // const warrantBaseUrl = 'http://192.168.1.103:8084/' //郑云
    // const upImgBaseUrl = 'http://192.168.1.103:8888/ImageServer/YmUpload_image'; //郑云测试
const upImgBaseUrl = 'https://api.yichengshi.cn/YmUpload_image';
const baseUrl = 'https://api.yichengshi.cn/'
// const baseUrl = 'http://test.yichengshi.cn/'

const instance = axios.create({
    baseURL: baseUrl,
    timeout: 10000,
    // withCredentials: false
})
const gasInstance = axios.create({
        baseURL: baseUrl,
        timeout: 10000,
        // withCredentials: false // 正式
    })
    // const gasInstance = axios.create({
    //     baseURL: warrantBaseUrl,
    //     timeout: 10000,
    //     // withCredentials: true   测试
    // })
instance.interceptors.request.use(config => {
    try {
        // let userList = JSON.parse(localStorage.getItem("userList1")) ? JSON.parse(localStorage.getItem("userList1")) : '';
        let userList = Vue.prototype.getCookie("userList") ? JSON.parse(Vue.prototype.getCookie("userList")) : '';
        let sessionId = userList ? userList.sessionId : '';
        let userId = userList ? userList.id : '';
        let headerOpts = {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
        };
        console.log(userId, "userId")
        if (userId) {
            let param = qs.parse(config.data)
            param.userId = userId
            param.sessionId = sessionId
            config.data = qs.stringify(param)
        }
        config.headers = headerOpts;
    } catch (e) {
        console.log(e)
    }
    return config
})

instance.interceptors.response.use(
    response => {
        // 在这里你可以判断后台返回数据携带的请求码
        // console.log(response)
        if (response.data.code === 0) {
            return response.data
        } else {
            // console.log(111)
            if (response.config.resParams) {
                if (response.config.resParams.notify == true) {
                    if (response.data.code == 2) {
                        localStorage.removeItem("sessionId")
                        localStorage.removeItem("userId");
                        // localStorage.removeItem("shopInformation")
                        router.push({ path: '/login' })
                    }
                }
            }
            return response.data
        }
    },
    error => {
        console.log('err', error)
        if (String(error).indexOf('401') > -1) {
            if (localStorage.token) {
                localStorage.removeItem("token")
            };
        }
        return Promise.reject(error)
    }
)

gasInstance.interceptors.request.use(config => {
    try {
        let userList = Vue.prototype.getCookie("userList") ? JSON.parse(Vue.prototype.getCookie("userList")) : '';
        let sessionId = userList ? userList.sessionId : '';
        let userId = userList ? userList.id : '';
        let headerOpts = {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
        };
        console.log(userId)
        if (userId) {
            let param = qs.parse(config.data)
            param.userId = userId
            param.sessionId = sessionId
            config.data = qs.stringify(param)
        }
        config.headers = headerOpts;
    } catch (e) {
        console.log(e)
    }
    return config
})

gasInstance.interceptors.response.use(
    response => {
        // 在这里你可以判断后台返回数据携带的请求码
        // console.log(response)
        if (response.data.code === 0) {
            return response.data
        } else {
            // console.log(111)
            if (response.config.resParams) {
                if (response.config.resParams.notify == true) {
                    if (response.data.code == 2) {
                        localStorage.removeItem("sessionId")
                        localStorage.removeItem("userId");
                        router.push({ path: '/login' })
                    }
                }
            }
            return response.data
        }
    },
    error => {
        console.log('err', error)
        if (String(error).indexOf('401') > -1) {
            if (localStorage.token) {
                localStorage.removeItem("token")
            };
        }
        return Promise.reject(error)
    }
)


export default {
    baseUrl,
    upImgBaseUrl,
    warrantBaseUrl,
    get(
        url,
        param,
        resParams = {
            notify: true
        }
    ) {
        return new Promise((resolve, reject) => {
            instance
                .get(url, {
                    params: param,
                    resParams: resParams
                })
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    post(
        url,
        param,
        resParams = {
            notify: true
        }
    ) {
        return new Promise((resolve, reject) => {
            instance
                .post(url, qs.stringify(param), {
                    resParams: resParams
                })
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    customPost(
        url,
        param,
        resParams = {
            notify: true
        },
        baseUrl = baseUrl,


    ) {
        return new Promise((resolve, reject) => {
            axios.create({
                    baseURL: baseUrl,
                    timeout: 10000,
                    withCredentials: false,
                    // headers: { "Content-Type": "multipart/form-data;boundary=" + new Date().getTime() }
                })
                .post(url, param, {
                    resParams: resParams
                })
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    gasPost(
        url,
        param,
        resParams = {
            notify: true
        },
        loading = true
    ) {
        return new Promise((resolve, reject) => {
            if (loading) {
                Store.state.loading = true
            }
            gasInstance.post(url, qs.stringify(param), {
                resParams: resParams
            }).then(res => {
                resolve(res)
                Store.state.loading = false
            }).catch(err => {
                reject(err)
                Store.state.loading = false
            })
        })
    },
}


// WEBPACK FOOTER //
// ./src/assets/request.js